import React, { useEffect, useState } from "react";
import BrandLogo from "../../components/atoms/brandLogo";
import { API_URL } from "../../constants";
import { toast } from "react-toastify";
import Invoice from "../../components/profile/invoice";
import { payment } from "../../validations/payment";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import PaymentStep1 from "../../components/profile/paymentstep1";
import PaymentStep2 from "../../components/profile/paymentstep2";
import PaymentReciept from "../../components/profile/paymentreciept";
import axios from "axios";
import wave from "../../assets/images/waves pattern.svg";
import {
  Container,
  HeaderImage,
  Heading,
  Card,
  AmountContainer,
  Amount,
  Number,
  TextArea,
  Next,
  OverLay,
} from "./styles";

type Formdata = yup.InferType<typeof payment>;

function Payment() {
  const [isInvoiceOpened, setIsInvoiceOpened] = useState(false);
  const [isPayment, setIsPayment] = useState(true);
  const [step1, setStep1] = useState(false);
  const [step2, setStep2] = useState(false);
  const [receipt, setReceipt] = useState(false);
  const [hero, setHero] = useState<any>();
  let [checkoutData, setCheckoutData] = useState({});
  const location = useLocation();
  let [profile, setProfile] = useState<any>();
  let [note, setNote] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [details, setDetails] = useState({
    accountNumber: "",
    bankName: "",
    accountName: "",
  });
  const {businessUuid} = location.state;

  const { register, handleSubmit, formState, reset } = useForm<Formdata>({
    resolver: yupResolver(payment),
  });
  const { errors } = formState;

  //form handler
  const submitHandler = (data: any) => {
    if (note) {
      const details = {
        phoneNumber: data.phoneNumber,
        amount: parseInt(data.amount),
        note: note,
      };
      setCheckoutData(details);
    } else
      setCheckoutData({
        phoneNumber: data.phoneNumber,
        amount: parseInt(data.amount),
      });

    setIsInvoiceOpened(true);
    setIsPayment(false);

    reset();
  };

  useEffect(
    () => {
      getProfile();
      getHero();
    },
    // eslint-disable-next-line
    []
  );

  const getProfile = async () => {
    const profile: any = await fetch(
      `${API_URL}/profile/${businessUuid}`
    ).catch((error) => {
      toast.error(error);
    });
    if (profile) {
      let result = await profile.json();
      setProfile(result.data);
    }
  };
    const getHero = async () => {
      axios
        .get(`${API_URL}/heroandHeader/${businessUuid}`)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            setHero(response.data.data);
          }
        })
        .catch((error) => {
          if (
            error?.response?.status === 400 ||
            error?.response?.status === 401
          ) {
            return;
          }
          toast.error("Connection Failed");
        });
    };


  const getDankDetails = (uuid: string) => {
    axios
      .get(`${API_URL}/bank_account_details/${businessUuid}`)
      .then((response: any) => {
        if (response.status === 200) {
          setDetails({
            bankName: response.data.data.accountDetails.BankName,
            accountName: response.data.data.accountDetails.accountName,
            accountNumber: response.data.data.accountDetails.accountNumber,
          });

          return;
        }
      })
      .catch((error) => {
        // toast.error("Failed to fetch profile");
        return;
      });
  };
  useEffect(
    () => {
      getDankDetails(businessUuid);
    },
    // eslint-disable-next-line
    [businessUuid]
  );

  return (
    <>
      {isPayment && (
        <Container className="bg-#FFF] pb-[5em] ">
          <HeaderImage>
            <img src={hero ? hero.headerImage : wave} alt="" />
          </HeaderImage>
          <Heading>
            <BrandLogo src={profile?.image} />
          </Heading>
          <Card onSubmit={handleSubmit(submitHandler)}>
            <h1>Pay / Support</h1>
            <AmountContainer>
              <div>
                <p>NGN</p>
              </div>
              <Amount
                placeholder="00.00*"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                {...register("amount")}
              />
            </AmountContainer>
            {errors?.amount && (
              <p className="text-xs mb-2 text-red-600">
                {errors.amount?.message}
              </p>
            )}
            <Number
              type="text"
              inputMode="numeric"
              {...register("phoneNumber")}
              pattern="[0-9]{11}"
              placeholder="Your Phone Number*"
            />
            {errors?.phoneNumber && (
              <p className="text-xs mb-2 text-red-600">
                {errors.phoneNumber?.message}
              </p>
            )}

            <TextArea
              placeholder="Note"
              onChange={(e) => {
                setNote(e.target.value);
              }}
            />
            <Next type="submit" value="Next" />
          </Card>
        </Container>
      )}
      {isInvoiceOpened && (
        <OverLay>
          <Invoice
            profile={profile}
            setIsInvoiceOpened={setIsInvoiceOpened}
            checkoutData={checkoutData}
            setStep1={setStep1}
            hero={hero}
            />
        </OverLay>
      )}
      {step1 && (
        <OverLay>
          <PaymentStep1
            profile={profile}
            setStep1={setStep1}
            setStep2={setStep2}
            checkoutData={checkoutData}
            setSelectedFile={setSelectedFile}
            selectedFile={selectedFile}
            details={details}
            hero={hero}
          />
        </OverLay>
      )}
      {step2 && (
        <OverLay>
          <PaymentStep2
            profile={profile}
            setStep2={setStep2}
            checkoutData={checkoutData}
            setReceipt={setReceipt}
            setSelectedFile={setSelectedFile}
            details={details}
            selectedFile={selectedFile}
            hero={hero}
          />
        </OverLay>
      )}
      {receipt && (
        <OverLay>
          <PaymentReciept
            profile={profile}
            setReceipt={setReceipt}
            checkoutData={checkoutData}
            selectedFile={selectedFile}
            hero={hero}
          />
        </OverLay>
      )}
    </>
  );
}

export default Payment;
